 <template>
  <div class="quotation">
    <div class="title">北京柯斯元纹理K防伪纸板</div>
    <h1>价格计算</h1>
    <div class="form">
      <div class="form-item">
        <label>单个面积</label>
        ：<input v-model="form.single" type="text" />
        <span>cm2</span>
      </div>
      <div class="form-item">
        <label>纸板克重选择</label>
        ：<span
          style="display: inline-block; margin-right: 10px"
          v-for="(item, key) in weightOptions"
          :key="key"
          ><input
            type="radio"
            name="form.weight"
            v-model="form.weight"
            style="vertical-align: middle"
            :value="item.price"
          />{{ item.label }}</span
        >
        <!-- <select v-model="form.weight" style="width: 147px">
          <option
            v-for="(item, key) in weightOptions"
            :value="item.price"
            :key="key"
          >
            {{ item.label }}
          </option>
        </select> -->
        <!-- <span>g/m2</span> -->
      </div>
      <div class="form-item">
        <label>图案存储查询时间</label>
        ：<input v-model="form.year" type="text" />
        <span>年</span>
      </div>
    </div>
    <div class="button-wapper">
      <span class="button" @click="compute">确 定</span>
    </div>
    <div class="tip">
      <div>说明：</div>
      <ul>
        <dd>总价格(含13%税收)=</dd>
        <li>1. 单个专利纤维纸板价格 +</li>
        <li>2.(喷码+印刷+图像拍照采集)价格 +</li>
        <li>3.(图片存储+查询费用)价格/年</li>
      </ul>
      其中：<br />
      <ul>
        <dd></dd>
        <li>
          1.单个专利纤维纸板价格（元）
          <div>
            =纸板克重g×纸板面积cm2×吨纸价格(元)÷10000000000<br />
            <span v-for="(item, key) in weightOptions" :key="key"
              >{{ item.label }}/m2:{{ item.price }}元/吨；<br
            /></span>
          </div>
        </li>
        <li>
          2.(喷码+印刷+图像拍照采集)价格
          <div>
            ={{ this.config.priceFor10cm }}×单个面积修正系数；<br />
            10cm2单个产品基础价格={{ this.config.priceFor10cm }}元<br />
            单个产品面积修正系数=1+[(单个面积-10)/10]×{{
              this.config.areaParams
            }}%
          </div>
        </li>
        <li>
          3.图案存储查询价格
          <div>={{ this.config.storagePrice }}×存储查询时间(年)</div>
        </li>
      </ul>
    </div>
    <div class="result" v-show="resultShow">
      <div class="title">北京柯斯元纹理K防伪纸板</div>
      <h1>价格计算结果</h1>
      <div class="price">
        <span style="font-size: 28px">{{ resultValue }}</span> 元/个
      </div>
      <div class="button-result">
        <span class="button" @click="resultShow = false">返 回</span>
      </div>
    </div>
  </div>
</template>
<script>
import { getDict } from "@/api/kHttpCode"
export default {
  data () {
    return {
      config: {},
      weightOptions: [{ label: '210g', price: 12000 }, { label: '300g', price: 10500 }, { label: '350g', price: 10000 }],
      form: {
        single: "",
        weight: "",
        year: 1
      },
      resultShow: false,
      resultValue: 0
    }
  },
  created () {
    getDict(164).then(res => {
      this.config = JSON.parse(res.data.remark)
      this.weightOptions = this.config.labelPrices
      console.log(this.config)
    })
  },
  methods: {
    compute () {
      if (this.form.single && this.form.weight && this.form.year) {
        let correctionFactor = 1 + (this.form.single - 10) / 10 * this.config.areaParams * 0.01
        let singlePrice = this.form.single < 10 ? 10 : this.form.single
        let zlPrice = singlePrice * this.form.weight / 10000000000
        let count = zlPrice +
          this.config.priceFor10cm * correctionFactor + this.config.storagePrice * this.form.year
        console.log(correctionFactor, singlePrice, zlPrice, count)
        this.resultValue = count.toFixed(6)
        this.resultShow = true
      }
      // this.$router.push({ path: '/quotationresult', query: { count: count.toFixed(6) } })
    }
  }
}
</script>
<style lang="scss" scoped>
.quotation {
  padding: 0.32rem;
  font-size: .4rem;
  .title,
  h1,
  .button {
    text-align: center;
  }
  h1 {
    font-size: 0.64rem;
    line-height: 2rem;
  }
  .form {
    .form-item {
      padding-bottom: 15px;
      label {
        display: inline-block;
        width: 3.5rem;
        text-align: right;
        vertical-align: middle;
      }
    }
    input[type='text'] {
      padding: 4px 8px;
      text-align: center;
      width: 80px;
    }
  }
  .button-wapper {
    text-align: center;
  }
  .button {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    transition: 0.1s;
    font-weight: 500;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    padding: 8px 15px;
    width: 80px;
    font-size: 12px;
    border-radius: 4px;
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
  }
  .tip {
    font-size: 14px;
    line-height: 0.6rem;
  }
  .result {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: #dcdfe6;
    padding: 16px;
    text-align: center;
    box-sizing: border-box;
    .button-result {
      width: 100%;
      height: 80px;
      position: absolute;
      bottom: 0;
      margin-left: -16px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/quotation/index.vue